import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

const UniqueMarker: React.FC = () => {
    return (
        <div className="aimed-unique-marker">
            <FullWrapper isMargin={false}>
                <div className="aimed-unique-markerWrapper">
                    <div className="aimed-unique-markerBlock">
                        <div className="aimed-unique-markerItem">
                            <img src='/images/pic/aimed/leadboard.png' alt="img" className="aimed-unique-markerImg" />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default UniqueMarker;